
import { connect } from 'react-redux';
import { OnboardingSummary } from "./onboarding-summary";
import {loadOnboardingData} from "../../onboarding/actions";

const mapDispatchToProps = dispatch => {
  return {
    loadOnboardingData: (index, username) => dispatch(loadOnboardingData(index, username)),
  };
};

const mapStateToProps = state => {
  return {
    token: state.user.token,
    config: state.app.config,
    onboarding: state.onboarding,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingSummary);
